import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fKeyTabInput,
  getUniqueValues,
  getUniqueValuesForBoolean,
  toYesNoOptions,
} from "../../Utility/Utilitys";
import {
  Active_TripId_Getrow,
  common_groupstructure_GETROW,
  Head_GeneratedApi,
  IMPUR01A_DeleteApi,
  IMPUR01A_Planning_ReverseAPi,
  IMPUR02B_GETROWApi,
  IMPUR02B_UpdateApi,
  IMPURTrip_attri,
} from "../../Server/ApiV2";
import { DataGridPro } from "@mui/x-data-grid-pro";
import moment from "moment";
import { vRdxUserInfo } from "../../Redux/roStore";
import GCAutocompleteCheckboxFixSizeUid from "./processComponent/GCAutocompleteCheckboxFixSizeUid";
import MainGroupComp from "./processComponent/MainGroupComponent";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import UserSelectionFilter from "./processComponent/UserSelectionFilter";

import { useSelector } from "react-redux";
import CustomToolbarWithMenu, {
  columnGroupingModel,
  columns,
  FinalQtyEditCell,
  fValidation,
  GetWmsStockRepotBrand,
  initialError,
  PL_BUCKETS,
} from "./ImportPurchaseAction";
import { confirmAlert } from "react-confirm-alert";
import {
  CmpDatePicker,
  CmpButtonV2,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import Formula from "./processComponent/Formula";
import GCBrandSearch from "../../Component/Common/ReuseableComponent/GCBrandSearch";

const ImportDetailModal = ({
  fOnClose,
  selectedRow,
  vRdxDBLocation,
  arrToCsv,
  vRdxuserLoc,
  setIsPopModalDataChanged,
  aMediaQuery,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:900px)");
  const [headerData, setHeaderData] = useState(selectedRow);

  const [errors, setErrors] = useState(initialError);
  const [sMainGroupData, setMainGroupData] = useState([]);
  const [gridData, setGridData] = useState([]);

  const [sBrandData, setBrandData] = useState([]);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const [stage, setStage] = useState("INITIAL");
  const [tripdata, setTripData] = useState([]);

  const [sOpenFilterModal, setOpenFilterModal] = useState(false);
  const handleOpen = () => setOpenFilterModal(true);
  const handleClose = () => setOpenFilterModal(false);

  const flags = useSelector(
    (state) => state.SliceIMPurchaseRequest.value.ImportPurchaseCheckbox
  );

  const uniqueCategoryValues = getUniqueValues(gridData, "CategoryCdName");
  const uniqueMainGrpValues = getUniqueValues(gridData, "MainGroupName");
  const uniqueSubGrpValues = getUniqueValues(gridData, "SubGroupName");
  const isReviewRaw  = getUniqueValuesForBoolean(gridData, "IsReview");
  const isReviewOptions = toYesNoOptions(isReviewRaw);
  const DetailGridCols = columns(setGridData,isReviewOptions,uniqueCategoryValues,uniqueMainGrpValues,uniqueSubGrpValues);

  const columnVisibilityModel = useMemo(() => {
    const model = {
      RowId: false, // always hidden
      CategoryCdName: true, // always shown
    };

    // For every PL bucket and every base key, map to PLxx_BaseKey
    Object.keys(flags).forEach((baseKey) => {
      PL_BUCKETS.forEach((pl) => {
        model[`${pl}_${baseKey}`] = !!flags[baseKey];
      });
    });

    DetailGridCols.forEach((c) => {
      if (model[c.field] === undefined) model[c.field] = true;
    });

    return model;
  }, [flags, DetailGridCols]);

  const FINAL_SUFFIX = "_Final_Qty";

  const originalRowsRef = React.useRef(new Map()); // RowId -> row

  const isFinalField = (f) => f.endsWith(FINAL_SUFFIX);

  // helper: recompute row "changed" against original snapshot
  const rowHasChanged = (row) => {
    const original = originalRowsRef.current.get(row.RowId) || {};
    return Object.keys(row).some(
      (k) => isFinalField(k) && Number(row[k] ?? 0) !== Number(original[k] ?? 0)
    );
  };

  const computedColumns = useMemo(() => {
    return DetailGridCols.map((c) =>
      c.field.endsWith(FINAL_SUFFIX)
        ? {
            ...c,
            type: "number",
            editable: true,
            align: c.align ?? "center",
            cellClassName: "editable-cell",
            valueParser: (value) => {
              const intValue = parseInt(value, 10);
              return isNaN(intValue) ? 0 : intValue;
            },
            renderEditCell: (params) => (
              <FinalQtyEditCell
                id={params.id}
                field={params.field}
                value={params.value}
                api={params.api}
              />
            ),
          }
        : c
    );
  }, [DetailGridCols]);

  const updateRowCell = useCallback((id, field, value) => {
    setGridData((prev) =>
      prev.map((r) => {
        if (r.RowId !== id) return r;
        // early bail if no change (prevents flicker & scroll jumps)
        if (Number(r[field] ?? 0) === Number(value ?? 0)) return r;

        const next = { ...r, [field]: value };
        return { ...next, isUpdated: rowHasChanged(next) };
      })
    );
  }, []);

  const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMgroup = async () => {
    let xGroupStructureObj = {
      Prnt: "",
      Lvl: "1",
    };
    await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
  };

  const fGenerate = async () => {
    const isValid = fValidation(headerData, setErrors);
    if (!isValid) return;

    const vRdxUserInfoObj = vRdxUserInfo();
    let vObj = {
      Loc: Array.isArray(headerData.Loc)
        ? arrToCsv(headerData.Loc)
        : headerData.Loc,
      Dept: Array.isArray(headerData.Group)
        ? arrToCsv(headerData.Group)
        : headerData.Group,
      Date1: moment(headerData.FromDate).format("MM/DD/YYYY"),
      Date2: moment(headerData.ToDate).format("MM/DD/YYYY"),
      UserCd: vRdxUserInfoObj?.UserID,
      TransId: Number(headerData.TransId),
      SubGroup: "",
      Group: "",
      LeadDays: headerData.LeadDays,
      ForecastDays: headerData.ForecastDays,
      TransLoc: headerData.TransLoc,
      Brand:
        headerData?.sBrandArr?.map((x) => x.UID).join(", ") ||
        headerData.A_BrandCd,
      TripId: headerData.TripId,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vObj);
    const resp = await Head_GeneratedApi(FinalObj);

    if (resp?.status === 200) {
      fGetRow(resp?.data?.ResultSet[0]?.A_TransId);
      setHeaderData((prev) => ({
        ...prev,
        TransId: resp?.data?.ResultSet[0]?.A_TransId,
      }));
      setIsPopModalDataChanged(true);
    } else {
      setGridData([]);
    }
  };

  const fGetRow = async (transId) => {
    // setIsGridLoading(true); // Start loader

    try {
      let FinalObj = fcheck_null_undefine_replace_empty({
        TransId: transId,
      });

      const resp = await IMPUR02B_GETROWApi(FinalObj);

      if (resp?.status === 200) {
        setGridData(resp?.data?.ResultSet);
      } else {
        setGridData([]);
      }
    } catch (error) {
      console.error("Error in fGetRow:", error);
      setGridData([]);
    } 
    // finally {
    //   setIsGridLoading(false); // Stop loader
    // }
  };

  console.log("isReview", gridData);

  const updatedPayload = useMemo(() => {
    return gridData?.filter((row) => row.isUpdated == true);
  }, [gridData]);

  const fSave = async (isStatus = false) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    if (updatedPayload?.length == 0) {
      fAlertToast(
        "FAILED",
        "No changes detected in the row. Please enter atleast one Final Qty or select a Review checklist to proceed with saving."
      );
      return;
    }

    let sObj = {
      TransId: headerData.TransId,
      UserCd: vRdxUserInfoObj?.UserID,
      isstatus: isStatus,
      Details: updatedPayload,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(sObj);
    const resp = await IMPUR02B_UpdateApi(FinalObj);

    if (resp?.status === 200) {
      if (isStatus === false) {
        fAlertToast("SUCCESS", "Transaction saved successfully");
        setIsPopModalDataChanged(true);
      } else {
        fAlertToast("SUCCESS", "Transaction posted successfully");
        fOnClose();
      }
    }
  };

  const fPost = async () => {
    if (headerData.DocStatus !== "ENTER") {
      fAlertToast("FAILED", "You are not allowed to post in post status");
      return;
    } else {
      confirmAlert({
        title: "Post",
        message: "Are you want to post the transaction.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: async () => {
              await fSave(true);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const fDelete = () => {
    if (headerData.DocStatus === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete the transaction.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: async () => {
              const vRdxUserInfoObj = vRdxUserInfo();

              let FinalObj = fcheck_null_undefine_replace_empty({
                TransId: headerData.TransId,
                UserCd: vRdxUserInfoObj?.UserID,
              });
              const resp = await IMPUR01A_DeleteApi(FinalObj);

              if (resp?.status === 200) {
                fAlertToast("SUCCESS", "Transaction saved successfully");
                fOnClose();
              }
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const fReverse = async () => {
    confirmAlert({
      title: "Reverse",
      message: "Are you want to reverse the transaction?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            const vRdxUserInfoObj = vRdxUserInfo();
            let FinalObj = fcheck_null_undefine_replace_empty({
              TransId: headerData.TransId,
              UserCd: vRdxUserInfoObj?.UserID,
            });
            const resp = await IMPUR01A_Planning_ReverseAPi(FinalObj);
            if (resp?.status === 200) {
              fAlertToast("SUCCESS", "Transaction reversed successfully");
              fOnClose();
            } else {
              fAlertToast("FAILED", "Transaction not reversed");
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const fLoad = async () => {
    if (headerData.TransId > 0) {
      fGetRow(headerData.TransId);
    }

    fMgroup();
    await GetWmsStockRepotBrand(setBrandData);
  };

  const fTrip = async () => {
    const result = await Active_TripId_Getrow({ TransId: headerData.TransId });
    console.log(result);

    if (result?.status === 200) {
      const data = result?.data?.ResultSet ?? [];
      setTripData(data);
    }
  };

  useEffect(() => {
    fLoad();
    fTrip();
  }, []);

  return (
    <>
      <Grid
        className="stock-detail"
        container
        columnSpacing={{ xs: 1, sm: 1.5, md: 2, lg: 2 }}
        rowSpacing={{ xs: 1, sm: 1, md: 2, lg: 2 }}
      >
        <Grid item xs={12} sm={12} md={7}>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 1, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
          >
            <Grid item xs={12} sm={6} md={3.5}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={5} lg={5}>
                  <CmpTypographyField xcomponent={"span"} xText={"TransId"} />
                </Grid>
                <Grid item xs={9.5} sm={8} md={7} lg={7}>
                  <TextField
                    value={headerData.TransId}
                    disabled={true}
                    autoComplete="off"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={4.2}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={4} lg={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"TransDate"} />
                </Grid>
                <Grid item xs={9.5} sm={8} md={8} lg={8}>
                  <CmpDatePicker
                    xName="Date"
                    xValue={headerData.Date}
                    xOnChange={(newValue) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        Date: newValue.$d,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        Date: "",
                      }));
                    }}
                    xDisable={true}
                    xFormat
                    xOnKeyUp={(e) => {
                      fKeyTabInput(e, "TransLoc");
                    }}
                    error={!!errors.Date}
                    helperText={errors.Date || ""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4.3}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={2} md={3} lg={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"TransLoc"} />
                </Grid>
                <Grid item xs={9.5} sm={10} md={9} lg={8}>
                  <Autocomplete
                    freeSolo
                    id="free-solo-2-demo"
                    disableClearable
                    options={vRdxuserLoc} // Use full objects
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.Name1
                    } // Support free text input
                    value={
                      vRdxuserLoc.find(
                        (loc) => loc.UID === headerData.TransLoc
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setHeaderData((prev) => ({
                          ...prev,
                          TransLoc: newValue, // Store typed value
                        }));
                      } else if (newValue) {
                        setHeaderData((prev) => ({
                          ...prev,
                          TransLoc: newValue.UID, // Store UID when selecting from dropdown
                        }));
                      }
                      setErrors((prev) => ({
                        ...prev,
                        TransLoc: "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="TransLoc"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            type: "search",
                          },
                        }}
                        autoComplete="off"
                        error={errors?.TransLoc === "" ? false : true}
                        helperText={errors?.TransLoc}
                      />
                    )}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "Group");
                    }}
                    disabled={gridData.length > 0}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={2} md={1.5} lg={1.5}>
                  <CmpTypographyField xcomponent={"span"} xText={"MainGroup"} />
                </Grid>

                <Grid item xs={9.5} sm={10} md={10.5} lg={10}>
                  <MainGroupComp
                    options={sMainGroupData}
                    xValue={headerData.Group} // CSV in, works now
                    xtabIndex="04"
                    xDisabled={
                      headerData?.sMainGroup?.toUpperCase() === "ALL" ||
                      gridData.length > 0
                    }
                    setValue={setHeaderData}
                    objName="Group"
                    onChangeCsv={(csv) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        Group: csv, // ✅ use the correct field instead of "c"
                      }));

                      setErrors((prev) => ({
                        ...prev,
                        Group: "", // ✅ clear the error when Group changes
                      }));
                    }} // keep CSV synced
                    label=""
                    name="Group"
                    placeholder="Search Main Group"
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "FromDate");
                    }}
                    error={!!errors.Group}
                    helperText={errors.Group || ""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 0, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
                className="stock-detail"
              >
                <Grid item xs={2.5} sm={2} md={1.5} lg={1.5}>
                  <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
                </Grid>
                <Grid item xs={9.5} sm={9.5} md={10.5} lg={10.5}>
                  <GCBrandSearch
                    xValue={headerData?.A_BrandCd} //main input value
                    xOnChange={(e) => {
                      setHeaderData((obj) => ({
                        ...obj,
                        A_BrandCd: e.target.value,
                      })); //main input onchange
                    }}
                    basketValue={headerData?.sBrandArr} //Search basket array
                    xListValue={headerData?.sBrandArr
                      ?.map((x) => x.Name1)
                      .join(", ")} // 2nd main input
                    onApply={(selectedObjects) => {
                      setHeaderData((obj) => ({
                        ...obj,
                        sBrandArr: selectedObjects || [],
                      }));
                    }}
                    xTitle={"importPlanning"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 0, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
                className="stock-detail"
              >
                <Grid item xs={2.5} sm={2} md={1.5} lg={1.5}>
                  <CmpTypographyField xcomponent={"span"} xText={"Trip ID"} />
                </Grid>
                <Grid item xs={9.5} sm={9.5} md={10.5} lg={10.5}>
                  <Autocomplete
                    id="trip-id-autocomplete"
                    options={tripdata}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option?.Name || ""
                    }
                    // value must be an option object or null
                    value={
                      tripdata?.find(
                        (trip) =>
                          String(trip.TripId) === String(headerData?.TripId)
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      String(option.TripId) === String(value.TripId)
                    }
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setHeaderData((prev) => ({
                          ...prev,
                          TripId: newValue,
                        }));
                      } else if (newValue) {
                        setHeaderData((prev) => ({
                          ...prev,
                          TripId: newValue.TripId,
                        }));
                      } else {
                        setHeaderData((prev) => ({
                          ...prev,
                          TripId: null,
                        }));
                      }

                      // ✅ CLEAR ERROR FOR ALL CASES
                      setErrors((prev) => ({
                        ...prev,
                        TripId: "",
                      }));
                    }}
                    disabled={gridData.length > 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="TripId"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            type: "search",
                          },
                        }}
                        error={!!errors.TripId}
                        helperText={errors.TripId || ""}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={5}>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 1, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 2 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={4} lg={4}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"AnalysisFromDate"}
                  />
                </Grid>
                <Grid item xs={9.5} sm={8} md={8} lg={8}>
                  <CmpDatePicker
                    xName="FromDate"
                    xValue={headerData.FromDate}
                    xOnChange={(newValue) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        FromDate: newValue.$d,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        FromDate: "",
                      }));
                    }}
                    xDisable={gridData.length > 0}
                    xOnKeyUp={(e) => {
                      fKeyTabInput(e, "ToDate");
                    }}
                    xError={!!errors.FromDate}
                    xErrorMessage={errors.FromDate || ""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={4} lg={4}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"AnalysisToDate"}
                  />
                </Grid>
                <Grid item xs={9.5} sm={8} md={8} lg={8}>
                  <CmpDatePicker
                    xName="ToDate"
                    xValue={headerData.ToDate}
                    xOnChange={(newValue) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        ToDate: newValue.$d,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        ToDate: "",
                      }));
                    }}
                    xDisable={gridData.length > 0}
                    xOnKeyUp={(e) => {
                      fKeyTabInput(e, "Loc");
                    }}
                    xError={!!errors.ToDate}
                    xErrorMessage={errors.ToDate || ""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={2} md={2} lg={2}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"AnalysisLoc"}
                  />
                </Grid>
                <Grid item xs={9.5} sm={10} md={10} lg={10}>
                  <GCAutocompleteCheckboxFixSizeUid
                    options={vRdxDBLocation}
                    xValue={headerData?.Loc}
                    // xtabIndex={"04"}
                    setValue={(updatedObj) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        Loc: updatedObj,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        Loc: "",
                      }));
                    }}
                    objName="Loc"
                    name="Loc"
                    label=""
                    placeholder="Search Location"
                    onChangeCsv={(csv) =>
                      setHeaderData((prev) => ({ ...prev, Loc: csv }))
                    }
                    xDisabled={gridData.length > 0}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "LeadDays");
                    }}
                    error={errors?.Loc === "" ? false : true}
                    helperText={errors?.Loc}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={4} lg={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"Lead Days"} />
                </Grid>
                <Grid item xs={9.5} sm={8} md={8} lg={8}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="LeadDays"
                    value={headerData.LeadDays}
                    onChange={(e) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        LeadDays: e.target.value,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        LeadDays: "",
                      }));
                    }}
                    disabled={gridData.length > 0}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "ForecastDays");
                    }}
                    autoComplete="off"
                    error={errors?.LeadDays === "" ? false : true}
                    helperText={errors?.LeadDays}
                    inputProps={{
                      step: 1,
                      pattern: "[0-9]*",
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "");
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 0.5, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={2.5} sm={4} md={5} lg={5}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"Forecast Days"}
                  />
                </Grid>
                <Grid item xs={9.5} sm={8} md={7} lg={7}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="ForecastDays"
                    autoComplete="off"
                    value={headerData.ForecastDays}
                    onChange={(e) => {
                      setHeaderData((prev) => ({
                        ...prev,
                        ForecastDays: e.target.value,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        ForecastDays: "",
                      }));
                    }}
                    disabled={gridData.length > 0}
                    error={errors?.ForecastDays === "" ? false : true}
                    helperText={errors?.ForecastDays}
                    inputProps={{
                      step: 1,
                      pattern: "[0-9]*",
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "");
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Generate"
                    xOnClick={() => {
                      fGenerate();
                      setStage("GENERATED");
                    }}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      (headerData.TransId != 0 ||
                        headerData?.DocStatus !== "ENTER") &&
                      gridData.length > 0
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Release"
                    xOnClick={() => {
                      setGridData([]);
                      setStage("RELEASED"); // update stage
                      setTimeout(() => {
                        document.getElementsByName("Date")[0].focus();
                      }, 400);
                    }}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      stage == "RELEASED" ||
                      headerData.TransId == 0 ||
                      headerData?.DocStatus !== "ENTER"
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Save"
                    xOnClick={() => fSave(false)}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      stage == "RELEASED" ||
                      headerData.TransId == 0 ||
                      headerData?.DocStatus !== "ENTER"
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Post"
                    xOnClick={fPost}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      stage == "RELEASED" ||
                      headerData.TransId == 0 ||
                      headerData?.DocStatus !== "ENTER"
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Delete"
                    xOnClick={fDelete}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      stage == "RELEASED" ||
                      headerData.TransId == 0 ||
                      headerData?.DocStatus !== "ENTER"
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  sx={{
                    textAlign: vMediaQuery ? "center" : "end",
                  }}
                >
                  <CmpButtonV2
                    xbtnName="Reverse"
                    xOnClick={fReverse}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      stage == "RELEASED" ||
                      headerData.TransId == 0 ||
                      headerData?.DocStatus === "ENTER" ||
                      headerData?.DocStatus === "DELETE" ||
                      headerData?.Pur_Status === "POST"
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <Box
          sx={{
            height: { xs: "70vh", sm: "60vh", md: "60vh", lg: "60vh" },
            width: "100%",
            marginTop: "1%",
          }}
        >
          <DataGridPro
            rows={gridData ? gridData : []}
            columns={computedColumns}
            getRowId={(row) => row.RowId}
            editMode="cell"
            rowHeight={20}
            headerHeight={30}
            // loading={isGridLoading}
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{ columnGrouping: true }}
            hideFooter={true}
            columnVisibilityModel={columnVisibilityModel}
            isCellEditable={(params) => params.field.endsWith(FINAL_SUFFIX)}
            onCellEditCommit={({ id, field, value }) => {
              if (!field.endsWith(FINAL_SUFFIX)) return;

              const num = Number(value);
              const nextVal = Number.isFinite(num) ? num : 0;

              // optional: skip if unchanged vs current (double safety, also done in updateRowCell)
              const curr = gridData.find((r) => r.RowId === id)?.[field];
              if (Number(curr ?? 0) === nextVal) return;

              updateRowCell(id, field, nextVal);
            }}
            sx={{
              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                color: "#24292e",
              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
                {
                  color: "#0298f5",
                },
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },

              "& .MuiDataGrid-cell": {
                padding: "0px 2px",
                fontSize: "9px",
              },
              "& .editable-cell": {
                backgroundColor: "#edfaff",
                border: " 1px solid lightgray",
              },
              // highlight input while editing
              "& .MuiDataGrid-cell--editing": {
                backgroundColor: "#d7edff",
              },
              "& .MuiDataGrid-cell--editing .MuiInputBase-root": {
                backgroundColor: "#d7edff",
                borderRadius: 1,
              },
              "& .MuiDataGrid-columnHeader": {
                whiteSpace: "normal",
                lineHeight: "1.2em",
                paddingTop: "6px",
                paddingBottom: "1px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                wordWrap: "break-word",
                fontSize: "8px !important", // Optional for better fit
              },
              "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
                {
                  backgroundColor: "#0d73bb",
                  color: "#fff",
                },
              "& .MuiDataGrid-pinnedColumnHeaders": {
                zIndex: 2,
                textAlign: "left",
              },
              "& .MuiDataGrid-pinnedColumns--left": {
                boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
              },
            }}
            initialState={{
              pinnedColumns: !vMediaQuery
                ? { left: ["CategoryCdName", "IsReview"] }
                : {},
            }}
            components={{
              Toolbar: CustomToolbarWithMenu,
            }}
            componentsProps={{
              toolbar: {
                setOpenContentModal,
                aMediaQuery,
                handleOpen,
                handleClose,
                setOpenFilterModal,
                sOpenFilterModal,
              },
            }}
          />
        </Box>
      </Grid>

      <CmpModal
        open={sOpenContentModal}
        onClose={() => setOpenContentModal(false)}
        title="Detail Filter"
        width={aMediaQuery ? "95%" : vMediaQuery ? "50%" : "40%"}
        height={aMediaQuery ? "36vh" : "42vh"}
        component={
          <UserSelectionFilter fClose={() => setOpenContentModal(false)} />
        }
      />

      <CmpModal
        open={sOpenFilterModal}
        onClose={() => setOpenFilterModal(false)}
        title="Formula"
        width={aMediaQuery ? "95%" : "70%"}
        height={aMediaQuery ? "70vh" : vMediaQuery ? "60vh" : "50vh"}
        vMediaQuery={aMediaQuery}
        component={<Formula fClose={() => setOpenFilterModal(false)} />}
      />
    </>
  );
};

export default ImportDetailModal;
